<template>
    <a v-bind:href="activityLink" target="_blank" class="block">
        <div class="col-md-12 no-padder">
            <a href="#" target="">
                <span></span>
            </a>
            <div>
                <a href="#" target=""></a>
                <a class="clear" target="_blank" v-bind:href="activity.object.url">{{ activity.object.comment }}</a>
            </div>
            <a class="clear shared-url" v-bind:href="activity.object.url" target="_blank"><br>
                <div class="panel panel-default">
                    <img class="img-full" v-bind:src="image"><br>
                    <div class="content-extract panel-footer wrapper-xs" style="position: relative; overflow: hidden;">
                        <h4 class="clear">{{ activity.object.title }}</h4>
                        <div>{{ activity.object.description }}</div>
                    </div>
                </div><br>
            </a>
                            
        </div>
    </a>
</template>

<script>
    export default {
        props: ['activity'],
        data(){
            return{
                activityLink : '',
                slug : ''
            }
        },
        mounted(){
            this.defineLink();
            // this.slug = this.object.slug ? this.object.slug : this.object.alias;
            // this.activityLink = `${window.user.community_url}/${window.user.community_domain}/default/post/view/${this.slug}`
        },
        computed: {
            object(){
                return this.activity.object ? this.activity.object : this.activity.content;
            },
            image(){
                return (this.activity.object && this.activity.object.avatar) ? this.activity.object.avatar : this.activity.content.avatar
            }
        },
        methods: {
            defineLink(){
                const baseLink = `${window.user.community_url}/${window.user.community_domain}/default/`;
                const slug = this.object.slug ? this.object.slug : this.object.alias;

                if(this.activity.object){
                    switch(this.activity.action_name){
                        case 'post_create':
                        case 'post_update':
                        case 'post_like':
                        case 'post_comment':
                        case 'post_comment_like':
                            this.activityLink = baseLink + `post/view/${slug}`;
                            break;
                        case 'media':
                            this.activityLink = baseLink + `corporate#/view/${this.activity.owner.id}/media`;
                            break;
                        case 'event_create':
                        case 'event_join':
                        case 'event_update':
                        case 'event_like':
                        case 'event_comment':
                        case 'event_comment_like':
                            this.activityLink = baseLink + `events/view/${slug}`;
                            break;
                        case 'wall':
                            this.activityLink = (this.object.type == 'article') ? this.object.url : '#';
                            break;
                        default:
                            this.activityLink = '#';
                            break;
                    }
                } else {
                    switch(this.activity.content_type){
                        case 'post':
                            this.activityLink = baseLink + `post/view/${slug}`;
                            break;
                        case 'event':
                            this.activityLink = baseLink + `events/view/${slug}`;
                            break;
                        case 'groups':
                            this.activityLink = baseLink + `groups/view/${slug}`;
                            break;
                        case 'blog':
                            this.activityLink = baseLink + `blog/view/${slug}`;
                            break;
                        case 'profile':
                            this.activityLink = baseLink + `profiles/view/${slug}`;
                            break;
                        default:
                            this.activityLink = '#';
                            break;
                    }
                }
            }
        }
    }
</script>

<style scoped>

@media only screen and (min-width: 1200px){
   
}
@media only screen and (max-width: 1199px) and (min-width: 1024px){

}
@media only screen and (max-width: 1023px) and (min-width: 768px){

}
@media only screen and (max-width: 767px){

}
</style>


